import type { ExperienceChapter } from "../types/exhibition";

export const EXPERIENCE_CHAPTERS: ReadonlyArray<ExperienceChapter> = [
  {
    id: "attract",
    index: 0,
    eyebrow: "XIANCHUANG · 00",
    title: "Precision, engineered.",
    marker: "00",
    state: "attract",
  },
  {
    id: "precision",
    index: 1,
    eyebrow: "PRECISION · 01",
    title: "From macro to micro.",
    marker: "01",
    state: "story",
  },
  {
    id: "scan",
    index: 2,
    eyebrow: "INSPECTION · 02",
    title: "Inside the structure.",
    marker: "02",
    state: "story",
  },
  {
    id: "sequence",
    index: 3,
    eyebrow: "SEQUENCE · 03",
    title: "Disassemble. Rebuild.",
    marker: "03",
    state: "hero",
  },
  {
    id: "universe",
    index: 4,
    eyebrow: "CATALOG · 04",
    title: "One system. Many forms.",
    marker: "04",
    state: "catalog",
  },
  {
    id: "hero",
    index: 5,
    eyebrow: "DETAIL · 05",
    title: "Every detail, resolved.",
    marker: "05",
    state: "hero",
  },
  {
    id: "finale",
    index: 6,
    eyebrow: "XIANCHUANG · 06",
    title: "Connections, in motion.",
    marker: "06",
    state: "attract",
  },
] as const;

export const CHAPTER_COUNT = EXPERIENCE_CHAPTERS.length;
